{
  "agreementUrl": "https://davstg.syngentadigitalapps.com/ProductAnalyzerGlobal/UserAgreement",
  "userManual": "https://syngenta.sharepoint.com/:f:/r/sites/EAMEseedscommercial-analyticsandreporting/Shared%20Documents/Product%20Analyzer?csf=1&web=1&e=FeodmZ",
  "faqUrl": "https://teams.microsoft.com/l/channel/19%3A27fca7a5f83843d9968eeeb0763ef456%40thread.tacv2/tab%3A%3A909cfa61-9d69-486d-974d-e7f121e11eba?groupId=1abaadf0-670e-4bb4-8b89-742004ad7353&tenantId=06219a4a-a835-44d5-afaf-3926343bfb89",
  "teamChannelUrl": "https://teams.microsoft.com/l/channel/19%3a27fca7a5f83843d9968eeeb0763ef456%40thread.tacv2/Product%2520Analyzer?groupId=1abaadf0-670e-4bb4-8b89-742004ad7353&tenantId=06219a4a-a835-44d5-afaf-3926343bfb89",
  "allRoles": ["Dept Admin", "Regional Admin", "Super Admin"],
  "allYieldUnits": [
    {
      "id": "1",
      "name": "sacos/ha",
      "crop": ["corn", "soy"],
      "region": ["latam"],
      "pairwiseLegends": [
        {
          "color": "#FFC000",
          "display": "< -2 sacos/ha"
        },
        {
          "color": "#fff",
          "display": "-2 to 2 sacos/ha"
        },
        {
          "color": "#92D050",
          "display": "> 2 sacos/ha"
        }
      ]
    },
    {
      "id": "2",
      "name": "t/ha",
      "crop": ["corn", "cornsilage", "winterbarley", "winterwheat", "soy"],
      "region": ["eame", "latam"],
      "pairwiseLegends": [
        {
          "color": "#FFC000",
          "display": "< -0.1 t/ha"
        },
        {
          "color": "#fff",
          "display": "-0.1 to 0.1 t/ha"
        },
        {
          "color": "#92D050",
          "display": "> 0.1 t/ha"
        }
      ]
    },
    {
      "id": "3",
      "name": "q/ha",
      "crop": ["sunflower"],
      "region": ["eame"],
      "pairwiseLegends": [
        {
          "color": "#FFC000",
          "display": "< -5 q/ha"
        },
        {
          "color": "#fff",
          "display": "-5 to 5 q/ha"
        },
        {
          "color": "#92D050",
          "display": "> 5 q/ha"
        }
      ]
    },
    {
      "id": "4",
      "name": "dt/ha",
      "crop": ["winteroilseeds"],
      "region": ["eame"],
      "pairwiseLegends": [
        {
          "color": "#FFC000",
          "display": "< -0.1 dt/ha"
        },
        {
          "color": "#fff",
          "display": "-0.1 to 0.1 dt/ha"
        },
        {
          "color": "#92D050",
          "display": "> 0.1 dt/ha"
        }
      ]
    }
  ],
  "allBrands": [
    {
      "id": "1",
      "code": "HIGH_NAME",
      "title": "Commercial",
      "region": ["EAME", "LATAM", "AMEA"]
    },
    {
      "id": "3",
      "code": "ABBR_CODE",
      "title": "Experimental",
      "region": ["EAME", "LATAM", "AMEA"]
    },
    {
      "id": "5",
      "code": "HYBRID_ID",
      "title": "Hybrid Id",
      "region": null
    },
    {
      "id": "8",
      "code": "GOLDEN_HARVEST_CODE",
      "title": "Golden Harvest Code",
      "region": null
    },
    {
      "id": "9",
      "code": "NK_CODE",
      "title": "NK Code",
      "region": null
    },
    {
      "id": "11",
      "code": "VARIETY_ID",
      "title": "Variety Id",
      "region": ["EAME", "AMEA"]
    },
    {
      "id": "12",
      "code": "GOLDEN_HARVEST_CODE_CHASSIS",
      "title": "Golden Harvest Code Chassis",
      "region": null
    },
    {
      "id": "13",
      "code": "NK_CODE_CHASSIS",
      "title": "NK Code Chassis",
      "region": null
    },
    {
      "id": "14",
      "code": "HYBRID_ID_CHASSIS",
      "title": "Hybrid Id Chassis",
      "region": null
    },
    {
      "id": "15",
      "code": "ENOGEN_CODE",
      "title": "Enogen Code",
      "region": null
    },
    {
      "id": "16",
      "code": "ENOGEN_CODE_CHASSIS",
      "title": "Enogen Code Chassis",
      "region": null
    }
  ],
  "allModes": [
    {
      "id": "1",
      "name": "Full"
    },
    {
      "id": "2",
      "name": "Lite"
    }
  ],
  "allModules": [
    {
      "id": "1",
      "name": "performance"
    },
    {
      "id": "2",
      "name": "SeedSelector"
    },
    {
      "id": "3",
      "name": "product-management"
    }
  ],
  "allRegions": [
    {
      "id": "1",
      "name": "NA"
    },
    {
      "id": "2",
      "name": "EAME"
    },
    {
      "id": "3",
      "name": "LATAM"
    },
    {
      "id": "4",
      "name": "AMEA"
    }
  ],
  "themes": [
    {
      "name": "GH",
      "id": "1"
    },
    {
      "name": "NK",
      "id": "2"
    },
    {
      "name": "DEFAULT",
      "id": "3"
    }
  ],
  "allCrops": [
    {
      "id": "1",
      "name": "CORN",
      "label": "Grain Corn"
    },
    {
      "id": "3",
      "name": "Sunflower",
      "label": "Sunflower"
    },
    {
      "id": "4",
      "name": "CornSilage",
      "label": "Silage Corn"
    },
    {
      "id": "2",
      "name": "SOY",
      "label": "SOY"
    },
    {
      "id": "2",
      "name": "Soy",
      "label": "SOY"
    },
    {
      "id": "5",
      "name": "WinterBarley",
      "label": "Winter Barley"
    },
    {
      "id": "6",
      "name": "WinterWheat",
      "label": "Winter Wheat"
    },
    {
      "id": "7",
      "name": "WinterOilSeeds",
      "label": "Winter Oilseed Rape"
    }
  ],
  "allCropSeasons": [
    {
      "id": "1",
      "value": "winter",
      "label": "Safrinha",
      "crop": ["corn"],
      "region": ["latam"]
    },
    {
      "id": "2",
      "value": "summer",
      "label": "Safra",
      "crop": ["corn"],
      "region": ["latam"]
    }
  ],
  "allCountry": [
    {
      "Region": "EAME",
      "Crop": "Corn",
      "Country": "Bulgaria"
    },
    {
      "Region": "EAME",
      "Crop": "Corn",
      "Country": "Czech Republic"
    },
    {
      "Region": "EAME",
      "Crop": "Corn",
      "Country": "Germany"
    },
    {
      "Region": "EAME",
      "Crop": "Corn",
      "Country": "Hungary"
    },
    {
      "Region": "EAME",
      "Crop": "Corn",
      "Country": "Italy"
    },
    {
      "Region": "EAME",
      "Crop": "Corn",
      "Country": "Poland"
    },
    {
      "Region": "EAME",
      "Crop": "Corn",
      "Country": "Romania"
    },
    {
      "Region": "EAME",
      "Crop": "Corn",
      "Country": "Russia"
    },
    {
      "Region": "EAME",
      "Crop": "Corn",
      "Country": "Slovakia"
    },
    {
      "Region": "EAME",
      "Crop": "Corn",
      "Country": "Ukraine"
    },
    {
      "Region": "EAME",
      "Crop": "CornSilage",
      "Country": "Czech Republic"
    },
    {
      "Region": "EAME",
      "Crop": "CornSilage",
      "Country": "Germany"
    },
    {
      "Region": "EAME",
      "Crop": "CornSilage",
      "Country": "Italy"
    },
    {
      "Region": "EAME",
      "Crop": "CornSilage",
      "Country": "Poland"
    },
    {
      "Region": "EAME",
      "Crop": "CornSilage",
      "Country": "Russia"
    },
    {
      "Region": "EAME",
      "Crop": "CornSilage",
      "Country": "Slovakia"
    },
    {
      "Region": "LATAM",
      "Crop": "Corn",
      "Country": "Brazil"
    },
    {
      "Region": "LATAM",
      "Crop": "Soy",
      "Country": "Brazil"
    },
    {
      "Region": "EAME",
      "Crop": "Sunflower",
      "Country": "Bulgaria"
    },
    {
      "Region": "EAME",
      "Crop": "Sunflower",
      "Country": "Germany"
    },
    {
      "Region": "EAME",
      "Crop": "Sunflower",
      "Country": "Hungary"
    },
    {
      "Region": "EAME",
      "Crop": "Sunflower",
      "Country": "Italy"
    },
    {
      "Region": "EAME",
      "Crop": "Sunflower",
      "Country": "Poland"
    },
    {
      "Region": "EAME",
      "Crop": "Sunflower",
      "Country": "Romania"
    },
    {
      "Region": "EAME",
      "Crop": "Sunflower",
      "Country": "Russia"
    },
    {
      "Region": "EAME",
      "Crop": "Sunflower",
      "Country": "Ukraine"
    },
    {
      "Region": "EAME",
      "Crop": "WinterBarley",
      "Country": "Belgium"
    },
    {
      "Region": "EAME",
      "Crop": "WinterBarley",
      "Country": "Bulgaria"
    },
    {
      "Region": "EAME",
      "Crop": "WinterBarley",
      "Country": "Czech Republic"
    },
    {
      "Region": "EAME",
      "Crop": "WinterBarley",
      "Country": "France"
    },
    {
      "Region": "EAME",
      "Crop": "WinterBarley",
      "Country": "Germany"
    },
    {
      "Region": "EAME",
      "Crop": "WinterBarley",
      "Country": "Hungary"
    },
    {
      "Region": "EAME",
      "Crop": "WinterBarley",
      "Country": "Netherlands"
    },
    {
      "Region": "EAME",
      "Crop": "WinterBarley",
      "Country": "Poland"
    },
    {
      "Region": "EAME",
      "Crop": "WinterBarley",
      "Country": "Romania"
    },
    {
      "Region": "EAME",
      "Crop": "WinterBarley",
      "Country": "Russia"
    },
    {
      "Region": "EAME",
      "Crop": "WinterBarley",
      "Country": "Serbia"
    },
    {
      "Region": "EAME",
      "Crop": "WinterBarley",
      "Country": "Slovakia"
    },
    {
      "Region": "EAME",
      "Crop": "WinterBarley",
      "Country": "Ukraine"
    },
    {
      "Region": "EAME",
      "Crop": "WinterBarley",
      "Country": "United Kingdom"
    },
    {
      "Region": "EAME",
      "Crop": "WinterOilSeeds",
      "Country": ""
    },
    {
      "Region": "EAME",
      "Crop": "WinterWheat",
      "Country": "Belgium"
    },
    {
      "Region": "EAME",
      "Crop": "WinterWheat",
      "Country": "Bulgaria"
    },
    {
      "Region": "EAME",
      "Crop": "WinterWheat",
      "Country": "Czech Republic"
    },
    {
      "Region": "EAME",
      "Crop": "WinterWheat",
      "Country": "France"
    },
    {
      "Region": "EAME",
      "Crop": "WinterWheat",
      "Country": "Germany"
    },
    {
      "Region": "EAME",
      "Crop": "WinterWheat",
      "Country": "Hungary"
    },
    {
      "Region": "EAME",
      "Crop": "WinterWheat",
      "Country": "Netherlands"
    },
    {
      "Region": "EAME",
      "Crop": "WinterWheat",
      "Country": "Poland"
    },
    {
      "Region": "EAME",
      "Crop": "WinterWheat",
      "Country": "Romania"
    },
    {
      "Region": "EAME",
      "Crop": "WinterWheat",
      "Country": "Russia"
    },
    {
      "Region": "EAME",
      "Crop": "WinterWheat",
      "Country": "Serbia"
    },
    {
      "Region": "EAME",
      "Crop": "WinterWheat",
      "Country": "Slovakia"
    },
    {
      "Region": "EAME",
      "Crop": "WinterWheat",
      "Country": "Ukraine"
    },
    {
      "Region": "EAME",
      "Crop": "WinterWheat",
      "Country": "United Kingdom"
    }
  ],
  "userCountry": [
    "Andorra",
    "Albania",
    "Armenia",
    "Austria",
    "Azerbaijan",
    "Bosnia and Herzegovina",
    "Belgium",
    "Bulgaria",
    "Belarus",
    "Switzerland",
    "Cyprus",
    "Czech Republic",
    "Germany",
    "Denmark",
    "Estonia",
    "Spain",
    "Finland",
    "Faroe Islands",
    "France",
    "Georgia",
    "Gibraltar",
    "Greece",
    "Croatia",
    "Hungary",
    "Ireland",
    "Iceland",
    "Italy",
    "Kazakhstan",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Latvia",
    "Monaco",
    "Moldova",
    "Montenegro",
    "North Macedonia",
    "Malta",
    "Netherlands",
    "Norway",
    "Poland",
    "Portugal",
    "Romania",
    "Serbia",
    "Russia",
    "Sweden",
    "Slovenia",
    "Slovakia",
    "San Marino",
    "Turkey",
    "Ukraine",
    "United Kingdom",
    "Vatican City",
    "Brazil"
  ],
  "entryPerformance": {
    "defaultEntryType": {
      "EAME": "VARIETY_ID",
      "LATAM": "HIGH_NAME",
      "AMEA": "HIGH_NAME"
    },
    "summarySection": [
      {
        "key": "trials",
        "label": "PA_Trials",
        "unit": null,
        "value": null,
        "crop": [
          "corn",
          "cornlatam",
          "cornsilage",
          "sunflower",
          "winterbarley",
          "winterwheat",
          "winteroilseeds",
          "soy"
        ]
      },
      {
        "key": "winRatio",
        "label": "Win Ratio",
        "unit": {
          "corn": "%",
          "cornlatam": "%",
          "cornsilage": "%",
          "sunflower": "%",
          "winterbarley": "%",
          "winterwheat": "%",
          "winteroilseeds": "%",
          "soy": "%"
        },
        "value": null,
        "crop": [
          "corn",
          "cornlatam",
          "cornsilage",
          "sunflower",
          "winterbarley",
          "winterwheat",
          "winteroilseeds",
          "soy"
        ]
      },
      {
        "key": "tie",
        "label": "PA_TieRatio",
        "unit": {
          "corn": "%",
          "cornlatam": "%",
          "cornsilage": "%",
          "sunflower": "%",
          "winterbarley": "%",
          "winterwheat": "%",
          "winteroilseeds": "%",
          "soy": "%"
        },
        "value": null,
        "crop": ["cornlatam", "soy"]
      },
      {
        "key": "yield",
        "label": "Yield",
        "unit": {
          "cornlatam": "t/ha",
          "corn": "t/ha",
          "cornsilage": "t/ha",
          "sunflower": "q/ha",
          "winterbarley": "t/ha",
          "winterwheat": "t/ha",
          "winteroilseeds": "dt/ha",
          "soy": "t/ha"
        },
        "value": null,
        "crop": [
          "corn",
          "cornlatam",
          "cornsilage",
          "sunflower",
          "winterbarley",
          "winterwheat",
          "winteroilseeds",
          "soy"
        ]
      },
      {
        "key": "check",
        "label": "Check",
        "unit": {
          "corn": "%",
          "cornlatam": "%",
          "cornsilage": "%",
          "sunflower": "%",
          "winterbarley": "%",
          "winterwheat": "%",
          "winteroilseeds": "%",
          "soy": "%"
        },
        "value": null,
        "crop": [
          "corn",
          "cornlatam",
          "cornsilage",
          "sunflower",
          "winterbarley",
          "winterwheat",
          "winteroilseeds",
          "soy"
        ]
      },
      {
        "key": "yieldAdvantage",
        "label": "Yield Advantage",
        "unit": {
          "corn": "t/ha",
          "cornlatam": "t/ha",
          "cornsilage": "t/ha",
          "sunflower": "q/ha",
          "winterbarley": "t/ha",
          "winterwheat": "t/ha",
          "winteroilseeds": "dt/ha",
          "soy": "t/ha"
        },
        "value": null,
        "crop": [
          "corn",
          "cornlatam",
          "cornsilage",
          "sunflower",
          "winterbarley",
          "winterwheat",
          "winteroilseeds",
          "soy"
        ]
      },
      {
        "key": "fao",
        "label": "FAO",
        "unit": {
          "corn": "",
          "cornsilage": ""
        },
        "value": null,
        "crop": ["corn", "cornsilage"]
      },
      {
        "key": "relativeMaturity",
        "label": "Relative Maturity",
        "unit": null,
        "value": null,
        "crop": ["corn", "cornsilage", "soy"]
      }
    ],
    "defaultSelectedFilters": {
      "corneame": {
        "relativeMaturity": {
          "key": "relativeMaturity",
          "rParam": "relativeMaturity",
          "title": "PA_RelativeMaturity",
          "values": null
        },
        "minLocations": {
          "key": "minLocations",
          "rParam": "minLocations",
          "title": "min_no_of_locations",
          "values": 8
        }
      },
      "cornsilageeame": {
        "minLocations": {
          "key": "minLocations",
          "rParam": "minLocations",
          "title": "min_no_of_locations",
          "values": 8
        },
        "relativeMaturity": {
          "key": "relativeMaturity",
          "rParam": "relativeMaturity",
          "title": "PA_RelativeMaturity",
          "values": null
        }
      },
      "sunflowereame": {
        "minLocations": {
          "key": "minLocations",
          "rParam": "minLocations",
          "title": "min_no_of_locations",
          "values": 5
        }
      },
      "winterbarleyeame": {
        "minLocations": {
          "key": "minLocations",
          "rParam": "minLocations",
          "title": "min_no_of_locations",
          "values": 8
        }
      },
      "winterwheateame": {
        "minLocations": {
          "key": "minLocations",
          "rParam": "minLocations",
          "title": "min_no_of_locations",
          "values": 8
        }
      },
      "winteroilseedseame": {
        "minLocations": {
          "key": "minLocations",
          "rParam": "minLocations",
          "title": "min_no_of_locations",
          "values": 1
        }
      },
      "cornlatam": {
        "minLocations": {
          "key": "minLocations",
          "rParam": "minLocations",
          "title": "min_no_of_locations",
          "values": 7
        },
        "cropSeason": {
          "key": "cropSeason",
          "rParam": "cropSeason",
          "title": "crop_season",
          "values": null
        }
      },
      "soylatam": {
        "rmtN": {
          "key": "rmtN",
          "rParam": "rmtN",
          "title": "PA_RelativeMaturity",
          "values": null
        },
        "minLocations": {
          "key": "minLocations",
          "rParam": "minLocations",
          "title": "min_no_of_locations",
          "values": 7
        }
      }
    },
    "defaultHeatmapFilters": {
      "corn": {
        "x_trait": {
          "title": "Selected TraitX",
          "rParam": "x_trait",
          "key": "x_trait",
          "values": "TEMP_PRECIP"
        },
        "y_trait": {
          "title": "Selected TraitY",
          "rParam": "y_trait",
          "key": "y_trait",
          "values": "TEXTURE"
        },
        "trait": {
          "title": "Selected Trait",
          "rParam": "trait",
          "key": "trait",
          "values": "YGSMN"
        },
        "plotTraits": [
          {
            "value": "SLK5N",
            "label": "PA_DaysSLK5N"
          },
          {
            "value": "ERTLP",
            "label": "PA_EarlyRootLodging"
          },
          {
            "value": "YGHMN",
            "label": "PA_GrainyieldHarvMst"
          },
          {
            "value": "GRSNP",
            "label": "PA_LateGreensnap"
          },
          {
            "value": "LRTLP",
            "label": "PA_LateRootLodging"
          },
          {
            "value": "GMSTP",
            "label": "PA_MoistureGMSTP"
          },
          {
            "value": "NHL_P",
            "label": "PA_NaturalHarvestLodging"
          },
          {
            "value": "ERTLR",
            "label": "PA_RootLodgingEarlyRating"
          },
          {
            "value": "STKLP",
            "label": "PA_StalkLodging"
          },
          {
            "value": "TWSMN",
            "label": "PA_TestWeight"
          },
          {
            "value": "YGSMN",
            "label": "PA_Yield_YGSMN"
          }
        ]
      },
      "cornlatam": {
        "x_trait": {
          "title": "Selected TraitX",
          "rParam": "x_trait",
          "key": "x_trait",
          "values": "PLANTING_WINDOW"
        },
        "y_trait": {
          "title": "Selected TraitY",
          "rParam": "y_trait",
          "key": "y_trait",
          "values": "ENV_CLASS"
        },
        "trait": {
          "title": "Selected Trait",
          "rParam": "trait",
          "key": "trait",
          "values": "YGSMN"
        },
        "plotTraits": [
          {
            "value": "YGSMN",
            "label": "PA_Yield_YGSMN"
          }
        ]
      },
      "cornsilage": {
        "x_trait": {
          "title": "Selected TraitX",
          "rParam": "x_trait",
          "key": "x_trait",
          "values": "TEMP_PRECIP"
        },
        "y_trait": {
          "title": "Selected TraitY",
          "rParam": "y_trait",
          "key": "y_trait",
          "values": "TEXTURE"
        },
        "trait": {
          "title": "Selected Trait",
          "rParam": "trait",
          "key": "trait",
          "values": "YSDMN"
        },
        "plotTraits": [
          {
            "value": "ADF_P",
            "label": "PA_AcidDetergentFiber"
          },
          {
            "value": "ADL_P",
            "label": "PA_AcidDetergentLignin"
          },
          {
            "value": "ASH_P",
            "label": "PA_Ash"
          },
          {
            "value": "CSMPP",
            "label": "PA_CommonSmut"
          },
          {
            "value": "DNDFP",
            "label": "PA_DigestibilityNDFBasedOnM4.2"
          },
          {
            "value": "DIGEP",
            "label": "PA_DigestibilityOfWholePlant"
          },
          {
            "value": "SDMCP",
            "label": "PA_DryMatterContent"
          },
          {
            "value": "DMSOP",
            "label": "PA_DryMatterSilageOnlinePercent"
          },
          {
            "value": "FSTRP",
            "label": "PA_ForageStarchContent"
          },
          {
            "value": "HEL1R",
            "label": "PA_H_Turcicum"
          },
          {
            "value": "NDF_P",
            "label": "PA_NeutralDetergentFiber"
          },
          {
            "value": "PLHTN",
            "label": "PA_PlantHeight"
          },
          {
            "value": "PLTQR",
            "label": "PA_PlotQualityRating"
          },
          {
            "value": "SVGRR",
            "label": "PA_SeedlingVigor"
          },
          {
            "value": "SDWTN",
            "label": "PA_SilageDryWeightSDWTN"
          },
          {
            "value": "SGWTN",
            "label": "PA_SilageGreenWeightSGWTN"
          },
          {
            "value": "PTNHN",
            "label": "PA_SilageProteinYield"
          },
          {
            "value": "YSDMN",
            "label": "PA_SilageYieldDryMatterYSDMN"
          },
          {
            "value": "YSHMN",
            "label": "PA_SilageYieldAtHarvMST"
          },
          {
            "value": "SSU_P",
            "label": "PA_SoluableSugarSSU_P"
          },
          {
            "value": "STKLP",
            "label": "PA_StalkLodgingSTKLP"
          },
          {
            "value": "STNHN",
            "label": "PA_StarchYieldSTNHN"
          },
          {
            "value": "STGRR",
            "label": "PA_StayGreenRatingSTGRR"
          },
          {
            "value": "TRLQR",
            "label": "PA_TrialQualityRatingTRLQR"
          },
          {
            "value": "UFL",
            "label": "PA_UFL"
          },
          {
            "value": "UFLHN",
            "label": "PA_UFLperhectareUFLHN"
          },
          {
            "value": "UFL4N",
            "label": "PA_UFLperhectareUFL4N"
          },
          {
            "value": "WPP_P",
            "label": "PA_WholePlantProteinWPP_P"
          }
        ]
      },
      "sunflower": {
        "x_trait": {
          "title": "Selected TraitX",
          "rParam": "x_trait",
          "key": "x_trait",
          "values": "TEMP_PRECIP"
        },
        "y_trait": {
          "title": "Selected TraitY",
          "rParam": "y_trait",
          "key": "y_trait",
          "values": "TEXTURE"
        },
        "trait": {
          "title": "Selected Trait",
          "rParam": "trait",
          "key": "trait",
          "values": "YGSMN"
        },
        "plotTraits": [
          {
            "value": "BrF_In",
            "label": "PA_BrF_In"
          },
          {
            "value": "BrX_Fq",
            "label": "PA_BrX_Fq"
          },
          {
            "value": "BrX_In",
            "label": "PA_BrX_In"
          },
          {
            "value": "DM_P",
            "label": "PA_DM_P"
          },
          {
            "value": "DM_R",
            "label": "PA_DM_R"
          },
          {
            "value": "YGHMN",
            "label": "PA_YGHMN"
          },
          {
            "value": "GMSTP",
            "label": "PA_MoistureGMSTP"
          },
          {
            "value": "OIL_P",
            "label": "PA_OIL_P"
          },
          {
            "value": "PLTQR",
            "label": "PA_PLTQR"
          },
          {
            "value": "ROOTP",
            "label": "PA_ROOTP"
          },
          {
            "value": "ROOTR",
            "label": "PA_ROOTR"
          },
          {
            "value": "SDVGR",
            "label": "PA_SDVGR"
          },
          {
            "value": "YGSMN",
            "label": "PA_Yield_YGSMN"
          }
        ]
      },
      "winterbarley": {
        "x_trait": {
          "title": "Selected TraitX",
          "rParam": "x_trait",
          "key": "x_trait",
          "values": "TEMP_PRECIP"
        },
        "y_trait": {
          "title": "Selected TraitY",
          "rParam": "y_trait",
          "key": "y_trait",
          "values": "TEXTURE"
        },
        "trait": {
          "title": "Selected Trait",
          "rParam": "trait",
          "key": "trait",
          "values": "YGTPH"
        },
        "plotTraits": [
          {
            "value": "GRA2_5",
            "label": "PA_GRA2_5"
          },
          {
            "value": "GRA2_8",
            "label": "PA_GRA2_8"
          },
          {
            "value": "BIOMA",
            "label": "PA_BIOMA"
          },
          {
            "value": "BRUST",
            "label": "PA_BRUST"
          },
          {
            "value": "UBRUST",
            "label": "PA_UBRUST"
          },
          {
            "value": "EARDT",
            "label": "PA_EARDT"
          },
          {
            "value": "UEARDT",
            "label": "PA_UEARDT"
          },
          {
            "value": "EAR_NECK",
            "label": "PA_EAR_NECK"
          },
          {
            "value": "UEAR",
            "label": "PA_UEAR"
          },
          {
            "value": "FERTE",
            "label": "PA_FERTE"
          },
          {
            "value": "FERM2",
            "label": "PA_FERM2"
          },
          {
            "value": "FUSA",
            "label": "PA_FUSA"
          },
          {
            "value": "GPEAR",
            "label": "PA_GPEAR"
          },
          {
            "value": "YGTPH",
            "label": "PA_YGTPH"
          },
          {
            "value": "LODG",
            "label": "PA_Lodging_LODG"
          },
          {
            "value": "ULODG",
            "label": "PA_Lodging_Untreated_ULODG"
          },
          {
            "value": "GMSTP",
            "label": "PA_MoistureGMSTP"
          },
          {
            "value": "SBMVR",
            "label": "PA_SBMVR_BYMVP"
          },
          {
            "value": "NETB",
            "label": "PA_Net_Blotch_NETB"
          },
          {
            "value": "UNETB",
            "label": "PA_UNETB"
          },
          {
            "value": "FLOOR",
            "label": "PA_FLOOR"
          },
          {
            "value": "EROWS",
            "label": "PA_EROWS"
          },
          {
            "value": "GPM2",
            "label": "PA_GPM2"
          },
          {
            "value": "PCELY",
            "label": "PA_PCELY"
          },
          {
            "value": "PCLAT",
            "label": "PA_PCLAT"
          },
          {
            "value": "UHT",
            "label": "PA_UHT"
          },
          {
            "value": "HT",
            "label": "PA_HT"
          },
          {
            "value": "PLGM2",
            "label": "PA_PLGM2"
          },
          {
            "value": "PCEM2",
            "label": "PA_PCEM2"
          },
          {
            "value": "PCLM2",
            "label": "PA_PCLM2"
          },
          {
            "value": "MILD",
            "label": "PA_Powdery_MILD"
          },
          {
            "value": "UMILD",
            "label": "PA_Powdery_Untreated_UMILD"
          },
          {
            "value": "PROT",
            "label": "PA_Protein_PROT"
          },
          {
            "value": "RAM",
            "label": "PA_Ramularia_RAM"
          },
          {
            "value": "URAM",
            "label": "PA_Ramularia_Untreated_URAM"
          },
          {
            "value": "SPTN2",
            "label": "PA_Rhincosporum_SPTN2"
          },
          {
            "value": "USPTN2",
            "label": "PA_Rhincosporum_UnTreated_USPTN2"
          },
          {
            "value": "GRA2_25",
            "label": "PA_GRA2_25"
          },
          {
            "value": "STABILITY",
            "label": "PA_Stability_STABILITY"
          },
          {
            "value": "STEM_BRACK",
            "label": "PA_STEM_BRACK"
          },
          {
            "value": "USTEM",
            "label": "PA_USTEM"
          },
          {
            "value": "TGW",
            "label": "PA_TGW"
          },
          {
            "value": "TWSMN",
            "label": "PA_TestWeight"
          },
          {
            "value": "TCELY",
            "label": "PA_TCELY"
          },
          {
            "value": "TCLAT",
            "label": "PA_TCLAT"
          },
          {
            "value": "TCEM2",
            "label": "PA_TCEM2"
          },
          {
            "value": "TCPLANT",
            "label": "PA_TCPLANT"
          },
          {
            "value": "DAW",
            "label": "PA_DAW"
          },
          {
            "value": "YRUST",
            "label": "PA_YRUST"
          },
          {
            "value": "YIELD_UNTRT",
            "label": "PA_YIELD_UNTRT"
          }
        ]
      },
      "winterwheat": {
        "x_trait": {
          "title": "Selected TraitX",
          "rParam": "x_trait",
          "key": "x_trait",
          "values": "TEMP_PRECIP"
        },
        "y_trait": {
          "title": "Selected TraitY",
          "rParam": "y_trait",
          "key": "y_trait",
          "values": "TEXTURE"
        },
        "trait": {
          "title": "Selected Trait",
          "rParam": "trait",
          "key": "trait",
          "values": "YGSMN"
        },
        "plotTraits": [
          {
            "value": "TGW_1000SEEDWEIGHT",
            "label": "PA_TGW_1000SEEDWEIGHT"
          },
          {
            "value": "W_ENERGY",
            "label": "PA_W_ENERGY"
          },
          {
            "value": "EARDE",
            "label": "PA_EARDE"
          },
          {
            "value": "FERM2",
            "label": "PA_FERM2"
          },
          {
            "value": "FUSMR",
            "label": "PA_FUSMR"
          },
          {
            "value": "HFN",
            "label": "PA_HFN"
          },
          {
            "value": "HAVPN",
            "label": "PA_HAVPN"
          },
          {
            "value": "HCTLW",
            "label": "PA_HCTLW"
          },
          {
            "value": "ZELENY_INDEX",
            "label": "PA_ZELENY_INDEX"
          },
          {
            "value": "INSDR",
            "label": "PA_INSDR"
          },
          {
            "value": "LDGER",
            "label": "PA_Lodging_LDGER"
          },
          {
            "value": "GMSTP",
            "label": "PA_MoistureGMSTP"
          },
          {
            "value": "HT",
            "label": "PA_Plant_Height"
          },
          {
            "value": "PLHTN",
            "label": "PA_Plant_Height_PLHTN"
          },
          {
            "value": "PDMS1",
            "label": "PA_Powedery_Mildew_Early_PDMS1"
          },
          {
            "value": "PRODU",
            "label": "PA_Protein_PRODU"
          },
          {
            "value": "PROT",
            "label": "PA_Protein_PROT"
          },
          {
            "value": "PROTEIN_CONTENT",
            "label": "PA_PROTEIN_CONTENT"
          },
          {
            "value": "RMT",
            "label": "PA_Relmaturity_RMT"
          },
          {
            "value": "SPNDR",
            "label": "PA_Septoria_SPNDR"
          },
          {
            "value": "SPTRR",
            "label": "PA_Septoria_Rating_SPTRR"
          },
          {
            "value": "STABILITY",
            "label": "PA_Stability_STABILITY"
          },
          {
            "value": "TWSMN",
            "label": "PA_TestWeight"
          },
          {
            "value": "UNFMR",
            "label": "PA_Uniformity_UNFMR"
          },
          {
            "value": "FLWGL",
            "label": "PA_Wet_Gluten"
          },
          {
            "value": "DAW",
            "label": "PA_Winter_Hardiness_DAW"
          },
          {
            "value": "YELR",
            "label": "PA_Yellow_Rust_YELR"
          },
          {
            "value": "YGSMN",
            "label": "PA_Yield_YGSMN"
          }
        ]
      },
      "winteroilseeds": {
        "x_trait": {
          "title": "Selected TraitX",
          "rParam": "x_trait",
          "key": "x_trait",
          "values": "YIELD_LVL"
        },
        "y_trait": {
          "title": "Selected TraitY",
          "rParam": "y_trait",
          "key": "y_trait",
          "values": "TEXTURE"
        },
        "trait": {
          "title": "Selected Trait",
          "rParam": "trait",
          "key": "trait",
          "values": "USDD"
        },
        "plotTraits": [
          {
            "value": "TKS",
            "label": "PA_1000_Kernel_Weight_Of_Fresh_Seed_TKS"
          },
          {
            "value": "BDA",
            "label": "PA_Biomass_Development_In_Autumn"
          },
          {
            "value": "BDS",
            "label": "PA_Biomass_Development_In_Spring"
          },
          {
            "value": "DOF",
            "label": "PA_Day_Begin_Of_Flowering"
          },
          {
            "value": "EOF",
            "label": "PA_Day_End_Of_Flowering"
          },
          {
            "value": "FLOP",
            "label": "PA_FLOP"
          },
          {
            "value": "DBM",
            "label": "PA_DBM"
          },
          {
            "value": "DBW",
            "label": "PA_Deficiencies_Before_Winter_DBW"
          },
          {
            "value": "EAB",
            "label": "PA_EAB"
          },
          {
            "value": "MAT",
            "label": "PA_MAT"
          },
          {
            "value": "GSL9",
            "label": "PA_GSL9"
          },
          {
            "value": "PHYT",
            "label": "PA_PHYT"
          },
          {
            "value": "LAF",
            "label": "PA_LAF"
          },
          {
            "value": "LBM",
            "label": "PA_LBM"
          },
          {
            "value": "HSH",
            "label": "PA_Moisture_HSH"
          },
          {
            "value": "OIL9",
            "label": "PA_OIL9"
          },
          {
            "value": "PIG2",
            "label": "PA_PIG2"
          },
          {
            "value": "PDS",
            "label": "PA_PDS"
          },
          {
            "value": "PLANT_HEIGHT",
            "label": "PA_PLANT_HEIGHT"
          },
          {
            "value": "PHS",
            "label": "PA_PHS"
          },
          {
            "value": "PRODM",
            "label": "PA_PRODM"
          },
          {
            "value": "PRO9",
            "label": "PA_PRO9"
          },
          {
            "value": "HD",
            "label": "PA_HD"
          },
          {
            "value": "ELA",
            "label": "PA_ELA"
          },
          {
            "value": "OUW",
            "label": "PA_OUW"
          },
          {
            "value": "SPD",
            "label": "PA_SPD"
          },
          {
            "value": "SSM",
            "label": "PA_SSM"
          },
          {
            "value": "SCM",
            "label": "PA_SCM"
          },
          {
            "value": "SSD",
            "label": "PA_SSD"
          },
          {
            "value": "SPM",
            "label": "PA_SPM"
          },
          {
            "value": "SVM",
            "label": "PA_SVM"
          },
          {
            "value": "SPA",
            "label": "PA_SPA"
          },
          {
            "value": "SPMA",
            "label": "PA_SPMA"
          },
          {
            "value": "UODD",
            "label": "PA_UODD"
          },
          {
            "value": "DAW",
            "label": "PA_DAW"
          },
          {
            "value": "USDD",
            "label": "PA_Yield_USDD"
          }
        ]
      },
      "soy": {
        "x_trait": {
          "title": "Selected TraitX",
          "rParam": "x_trait",
          "key": "x_trait",
          "values": "PLANTING_WINDOW"
        },
        "y_trait": {
          "title": "Selected TraitY",
          "rParam": "y_trait",
          "key": "y_trait",
          "values": "ENV_CLASS"
        },
        "trait": {
          "title": "Selected Trait",
          "rParam": "trait",
          "key": "trait",
          "values": "YGSMN"
        },
        "plotTraits": [
          {
            "value": "YGSMN",
            "label": "PA_Yield_YGSMN"
          }
        ]
      }
    },
    "defaultScatterPlotFilters": {
      "corn": {
        "trait": {
          "title": "Selected Traits",
          "rParam": "traits",
          "key": "traits",
          "values": "GMSTP,YGSMN"
        }
      },
      "cornsilage": {
        "trait": {
          "title": "Selected Traits",
          "rParam": "traits",
          "key": "traits",
          "values": "SDMCP,YSDMN"
        }
      },
      "sunflower": {
        "trait": {
          "title": "Selected Traits",
          "rParam": "traits",
          "key": "traits",
          "values": "GMSTP,YGSMN"
        }
      },
      "winterbarley": {
        "trait": {
          "title": "Selected Traits",
          "rParam": "traits",
          "key": "traits",
          "values": "TWSMN,YGTPH"
        }
      },
      "winterwheat": {
        "trait": {
          "title": "Selected Traits",
          "rParam": "traits",
          "key": "traits",
          "values": "GMSTP,YGSMN"
        }
      },
      "winteroilseeds": {
        "trait": {
          "title": "Selected Traits",
          "rParam": "traits",
          "key": "traits",
          "values": "HSH,USDD"
        }
      },
      "soy": {
        "trait": {
          "title": "Selected Traits",
          "rParam": "traits",
          "key": "traits",
          "values": "RMT_N,YGSMN"
        }
      }
    },
    "defaultPriceGuideFilters": {
      "corn": {
        "hybridsCompare": {
          "key": "hybridsCompare",
          "label": "PA_PriceGuidance_HybridsToCompare",
          "attributes": {
            "seedsPerBag": {
              "apiKey": "seed_price_per_bag",
              "key": "seedsPerBag",
              "label": "PA_SeedPrice/Bag",
              "value": 0
            }
          },
          "defaultHybrids": {
            "0": {
              "key": "0",
              "data": [],
              "value": null,
              "input": {
                "seedsPerBag": {
                  "key": "seedsPerBag",
                  "label": "PA_SeedPrice/Bag",
                  "value": 0
                }
              },
              "productKey": "(None)"
            },
            "1": {
              "key": "1",
              "data": [],
              "value": null,
              "input": {
                "seedsPerBag": {
                  "key": "seedsPerBag",
                  "label": "PA_SeedPrice/Bag",
                  "value": 0
                }
              },
              "productKey": "(None)"
            },
            "2": {
              "key": "2",
              "data": [],
              "value": null,
              "input": {
                "seedsPerBag": {
                  "key": "seedsPerBag",
                  "label": "PA_SeedPrice/Bag",
                  "value": 0
                }
              },
              "productKey": "(None)"
            },
            "3": {
              "key": "3",
              "data": [],
              "value": null,
              "input": {
                "seedsPerBag": {
                  "key": "seedsPerBag",
                  "label": "PA_SeedPrice/Bag",
                  "value": 0
                }
              },
              "productKey": "(None)"
            },
            "4": {
              "key": "4",
              "data": [],
              "value": null,
              "input": {
                "seedsPerBag": {
                  "key": "seedsPerBag",
                  "label": "PA_SeedPrice/Bag",
                  "value": 0
                }
              },
              "productKey": "(None)"
            }
          },
          "entryBlock": null
        },
        "profitLevelSetting": {
          "key": "profitLevelSetting",
          "label": "PA_PriceGuidance_ForProfitLevelSettings",
          "areaUnit": "ha",
          "yieldUnit": "t",
          "selectedCurrencyPerUnit": "€",
          "attributes": {
            "seedsPricePerUnit": {
              "key": "seedsPricePerUnit",
              "unit": "1000 seeds",
              "unitValue": null,
              "label": "Bag size",
              "value": 80
            },
            "currencyPerUnit": {
              "key": "currencyPerUnit",
              "label": "Currency",
              "value": {
                "key": "Euro",
                "sign": "€"
              },
              "unit": null,
              "unitValue": null,
              "options": [
                {
                  "key": "Euro",
                  "sign": "€"
                },
                {
                  "key": "BGN",
                  "sign": "Лв."
                },
                {
                  "key": "CZK",
                  "sign": "Kč"
                },
                {
                  "key": "GBP",
                  "sign": "£"
                },
                {
                  "key": "HRK",
                  "sign": "kn"
                },
                {
                  "key": "HUF",
                  "sign": "Ft"
                },
                {
                  "key": "PLN",
                  "sign": "zł"
                },
                {
                  "key": "RON",
                  "sign": "lei"
                },
                {
                  "key": "RSD",
                  "sign": "din"
                },
                {
                  "key": "RUB",
                  "sign": "₽"
                },
                {
                  "key": "TRY",
                  "sign": "₺"
                },
                {
                  "key": "UAH",
                  "sign": "₴"
                },
                {
                  "key": "USD",
                  "sign": "$"
                }
              ]
            },
            "plantingDensity": {
              "key": "plantingDensity",
              "unit": "1000 seeds/ha",
              "unitValue": null,
              "label": "Planting density",
              "value": 80
            },
            "commodityPrice": {
              "key": "commodityPrice",
              "unit": null,
              "unitValue": "t",
              "label": "Commodity Price",
              "value": 150
            },
            "standardMoisture": {
              "key": "standardMoisture",
              "unit": "%",
              "unitValue": null,
              "label": "Standard Moisture",
              "value": 14
            },
            "dryingCost": {
              "key": "dryingCost",
              "unit": null,
              "unitValue": "t",
              "label": "Drying Cost",
              "value": 0
            },
            "valueCapture": {
              "key": "valueCapture",
              "unit": "%",
              "unitValue": null,
              "label": "Value Capture",
              "value": 20
            },
            "cultivationCost": {
              "key": "cultivationCost",
              "unit": null,
              "unitValue": "ha",
              "label": "Cultivation Cost",
              "value": 0
            },
            "subsides": {
              "key": "subsides",
              "unit": null,
              "unitValue": "ha",
              "label": "Subsides",
              "value": 0
            }
          }
        },
        "cultivationCostPerYield": {
          "key": "cultivationCostPerYield",
          "label": "PA_PriceGuidance_CultivationCostPerYieldSegment",
          "unit": null,
          "unitValue": "ha",
          "attributes": null
        },
        "sortByTrait": "YIELD_LVL",
        "noOfAllowedCompetitors": 5,
        "roundDecimalNumber": 1,
        "title": "Price Guide",
        "title_translationKey": "PA_PriceGuidance_PriceGuide",
        "tooltipEnabled": false,
        "priceGuideData": {
          "checksList": [],
          "priceData": [],
          "qualityData": {},
          "profitData": {}
        },
        "entry": {
          "name": null,
          "seedPrice": 0,
          "hybridSpecificCost": 0,
          "hybridSpecificPremium": 0
        }
      },
      "cornsilage": {
        "hybridsCompare": {
          "key": "hybridsCompare",
          "label": "PA_PriceGuidance_HybridsToCompare",
          "attributes": null,
          "defaultHybrids": {
            "0": {
              "key": "0",
              "data": [],
              "value": null,
              "input": null,
              "productKey": null
            },
            "1": {
              "key": "1",
              "data": [],
              "value": null,
              "input": null,
              "productKey": null
            },
            "2": {
              "key": "2",
              "data": [],
              "value": null,
              "input": null,
              "productKey": null
            },
            "3": {
              "key": "3",
              "data": [],
              "value": null,
              "input": null,
              "productKey": null
            },
            "4": {
              "key": "4",
              "data": [],
              "value": null,
              "input": null,
              "productKey": null
            }
          },
          "entryBlock": null
        },
        "profitLevelSetting": {
          "key": "profitLevelSetting",
          "label": "Parameters",
          "areaUnit": "ha",
          "yieldUnit": "t",
          "selectedCurrencyPerUnit": "€",
          "attributes": {
            "currencyPerUnit": {
              "key": "currencyPerUnit",
              "label": "Currency",
              "value": {
                "key": "Euro",
                "sign": "€"
              },
              "unit": null,
              "unitValue": null,
              "options": [
                {
                  "key": "Euro",
                  "sign": "€"
                },
                {
                  "key": "BGN",
                  "sign": "Лв."
                },
                {
                  "key": "CZK",
                  "sign": "Kč"
                },
                {
                  "key": "GBP",
                  "sign": "£"
                },
                {
                  "key": "HRK",
                  "sign": "kn"
                },
                {
                  "key": "HUF",
                  "sign": "Ft"
                },
                {
                  "key": "PLN",
                  "sign": "zł"
                },
                {
                  "key": "RON",
                  "sign": "lei"
                },
                {
                  "key": "RSD",
                  "sign": "din"
                },
                {
                  "key": "RUB",
                  "sign": "₽"
                },
                {
                  "key": "TRY",
                  "sign": "₺"
                },
                {
                  "key": "UAH",
                  "sign": "₴"
                },
                {
                  "key": "USD",
                  "sign": "$"
                }
              ]
            },
            "maizeAcreage": {
              "key": "maizeAcreage",
              "unit": "ha",
              "unitValue": null,
              "label": "Maize acreage",
              "value": 20
            },
            "extraWinForYield": {
              "key": "extraWinForYield",
              "unit": null,
              "unitValue": "t",
              "label": "Extra win for yield",
              "value": 100
            },
            "countOfCows": {
              "key": "countOfCows",
              "unit": null,
              "unitValue": null,
              "label": "Count of cows",
              "value": 80
            },
            "extraWinForMilk": {
              "key": "extraWinForMilk",
              "unit": null,
              "unitValue": "year",
              "label": "Extra win for milk",
              "value": 10
            },
            "energyMeasure": {
              "key": "energyMeasure",
              "label": "Energy measure",
              "value": {
                "key": "UFL",
                "sign": "UFL"
              },
              "unit": null,
              "unitValue": null,
              "options": [
                {
                  "key": "UFL",
                  "sign": "UFL"
                }
              ]
            }
          }
        },
        "cultivationCostPerYield": null,
        "noOfAllowedCompetitors": 5,
        "roundDecimalNumber": 1,
        "title": "Price Guide",
        "title_translationKey": "PA_PriceGuidance_PriceGuide",
        "tooltipEnabled": false,
        "priceGuideData": {
          "checksList": [],
          "priceData": [],
          "qualityData": {},
          "profitData": {}
        },
        "entry": {
          "name": null,
          "seedPrice": 0,
          "hybridSpecificCost": 0,
          "hybridSpecificPremium": 0
        }
      },
      "sunflower": {
        "hybridsCompare": {
          "key": "hybridsCompare",
          "label": "Hybrids to compare",
          "entryBlock": {
            "key": "entryBlock",
            "label": "Entry",
            "attributes": {
              "seedsPerBag": {
                "key": "seedsPerBag",
                "apiKey": "seed_price_per_bag",
                "label": "Seed Price",
                "unitValue": "Bag",
                "calcKey": "seedPrice",
                "value": 0
              },
              "hybridSpecificCost": {
                "key": "hybridSpecificCost",
                "apiKey": "specific_cost_per_hectare",
                "calcKey": "hybridSpecificCost",
                "label": "Specific Cost",
                "unitValue": "ha",
                "value": 0
              },
              "hybridSpecificPremium": {
                "key": "hybridSpecificPremium",
                "apiKey": "specific_premium_per_hectare",
                "label": "Specific Premium",
                "calcKey": "hybridSpecificPremium",
                "unitValue": "ha",
                "value": 0
              }
            },
            "defaultHybrids": {
              "entry": {
                "key": "entry",
                "data": [],
                "value": null,
                "input": {
                  "seedsPerBag": {
                    "key": "seedsPerBag",
                    "label": "Seed Price",
                    "unitValue": "Bag",
                    "calcKey": "seedPrice",
                    "value": 0
                  },
                  "hybridSpecificCost": {
                    "key": "hybridSpecificCost",
                    "calcKey": "hybridSpecificCost",
                    "label": "Specific Cost",
                    "unitValue": "ha",
                    "value": 0
                  },
                  "hybridSpecificPremium": {
                    "key": "hybridSpecificPremium",
                    "label": "Specific Premium",
                    "calcKey": "hybridSpecificPremium",
                    "unitValue": "ha",
                    "value": 0
                  }
                },
                "productKey": null
              },
              "0": {
                "key": "0",
                "data": [],
                "value": null,
                "input": {
                  "seedsPerBag": {
                    "key": "seedsPerBag",
                    "label": "Seed Price",
                    "unitValue": "Bag",
                    "calcKey": "seedPrice",
                    "value": 0
                  },
                  "hybridSpecificCost": {
                    "key": "hybridSpecificCost",
                    "calcKey": "hybridSpecificCost",
                    "label": "Specific Cost",
                    "unitValue": "ha",
                    "value": 0
                  },
                  "hybridSpecificPremium": {
                    "key": "hybridSpecificPremium",
                    "label": "Specific Premium",
                    "calcKey": "hybridSpecificPremium",
                    "unitValue": "ha",
                    "value": 0
                  }
                },
                "productKey": null
              },
              "1": {
                "key": "1",
                "data": [],
                "value": null,
                "input": {
                  "seedsPerBag": {
                    "key": "seedsPerBag",
                    "label": "Seed Price",
                    "unitValue": "Bag",
                    "calcKey": "seedPrice",
                    "value": 0
                  },
                  "hybridSpecificCost": {
                    "key": "hybridSpecificCost",
                    "calcKey": "hybridSpecificCost",
                    "label": "Specific Cost",
                    "unitValue": "ha",
                    "value": 0
                  },
                  "hybridSpecificPremium": {
                    "key": "hybridSpecificPremium",
                    "label": "Specific Premium",
                    "calcKey": "hybridSpecificPremium",
                    "unitValue": "ha",
                    "value": 0
                  }
                },
                "productKey": null
              },
              "2": {
                "key": "2",
                "data": [],
                "value": null,
                "input": {
                  "seedsPerBag": {
                    "key": "seedsPerBag",
                    "label": "Seed Price",
                    "unitValue": "Bag",
                    "calcKey": "seedPrice",
                    "value": 0
                  },
                  "hybridSpecificCost": {
                    "key": "hybridSpecificCost",
                    "calcKey": "hybridSpecificCost",
                    "label": "Specific Cost",
                    "unitValue": "ha",
                    "value": 0
                  },
                  "hybridSpecificPremium": {
                    "key": "hybridSpecificPremium",
                    "label": "Specific Premium",
                    "calcKey": "hybridSpecificPremium",
                    "unitValue": "ha",
                    "value": 0
                  }
                },
                "productKey": null
              },
              "3": {
                "key": "3",
                "data": [],
                "value": null,
                "input": {
                  "seedsPerBag": {
                    "key": "seedsPerBag",
                    "label": "Seed Price",
                    "unitValue": "Bag",
                    "calcKey": "seedPrice",
                    "value": 0
                  },
                  "hybridSpecificCost": {
                    "key": "hybridSpecificCost",
                    "calcKey": "hybridSpecificCost",
                    "label": "Specific Cost",
                    "unitValue": "ha",
                    "value": 0
                  },
                  "hybridSpecificPremium": {
                    "key": "hybridSpecificPremium",
                    "label": "Specific Premium",
                    "calcKey": "hybridSpecificPremium",
                    "unitValue": "ha",
                    "value": 0
                  }
                },
                "productKey": null
              },
              "4": {
                "key": "4",
                "data": [],
                "value": null,
                "input": {
                  "seedsPerBag": {
                    "key": "seedsPerBag",
                    "label": "Seed Price",
                    "unitValue": "Bag",
                    "calcKey": "seedPrice",
                    "value": 0
                  },
                  "hybridSpecificCost": {
                    "key": "hybridSpecificCost",
                    "calcKey": "hybridSpecificCost",
                    "label": "Specific Cost",
                    "unitValue": "ha",
                    "value": 0
                  },
                  "hybridSpecificPremium": {
                    "key": "hybridSpecificPremium",
                    "label": "Specific Premium",
                    "calcKey": "hybridSpecificPremium",
                    "unitValue": "ha",
                    "value": 0
                  }
                },
                "productKey": null
              }
            }
          }
        },
        "profitLevelSetting": {
          "key": "profitLevelSetting",
          "label": "PA_PriceGuidance_ForProfitLevelSettings",
          "areaUnit": "ha",
          "yieldUnit": "t",
          "selectedCurrencyPerUnit": "€",
          "attributes": {
            "seedsPricePerUnit": {
              "key": "seedsPricePerUnit",
              "label": "Bag size",
              "unit": "1000 seeds",
              "unitValue": null,
              "value": 150
            },
            "currencyPerUnit": {
              "key": "currencyPerUnit",
              "label": "Currency",
              "unit": null,
              "unitValue": null,
              "value": {
                "key": "Euro",
                "sign": "€"
              },
              "options": [
                {
                  "key": "Euro",
                  "sign": "€"
                },
                {
                  "key": "BGN",
                  "sign": "Лв."
                },
                {
                  "key": "CZK",
                  "sign": "Kč"
                },
                {
                  "key": "GBP",
                  "sign": "£"
                },
                {
                  "key": "HRK",
                  "sign": "kn"
                },
                {
                  "key": "HUF",
                  "sign": "Ft"
                },
                {
                  "key": "PLN",
                  "sign": "zł"
                },
                {
                  "key": "RON",
                  "sign": "lei"
                },
                {
                  "key": "RSD",
                  "sign": "din"
                },
                {
                  "key": "RUB",
                  "sign": "₽"
                },
                {
                  "key": "TRY",
                  "sign": "₺"
                },
                {
                  "key": "UAH",
                  "sign": "₴"
                },
                {
                  "key": "USD",
                  "sign": "$"
                }
              ]
            },
            "plantingDensity": {
              "key": "plantingDensity",
              "label": "Planting density",
              "unit": "1000 seeds/ha",
              "unitValue": null,
              "value": 65
            },
            "commodityPrice": {
              "key": "commodityPrice",
              "label": "Commodity Price",
              "unit": null,
              "unitValue": "t",
              "value": 600
            },
            "oilPremiumThreshold": {
              "key": "oilPremiumThreshold",
              "label": "Oil premium threshold",
              "unit": "%",
              "unitValue": null,
              "value": 44
            },
            "oilPremiumLevel": {
              "key": "oilPremiumLevel",
              "label": "Oil premium level",
              "unit": "%",
              "unitValue": null,
              "value": 1.5
            },
            "oilPenaltyThreshold": {
              "key": "oilPenaltyThreshold",
              "label": "Oil penalty threshold",
              "unit": "%",
              "unitValue": null,
              "value": 44
            },
            "oilPenaltyLevel": {
              "key": "oilPenaltyLevel",
              "label": "Oil penalty level",
              "unit": "%",
              "unitValue": null,
              "value": 1.5
            },
            "standardMoisture": {
              "key": "standardMoisture",
              "label": "Standard Moisture",
              "unit": "%",
              "unitValue": null,
              "value": 9
            },
            "dryingCost": {
              "key": "dryingCost",
              "label": "Drying Cost",
              "unit": null,
              "unitValue": "t",
              "value": 0
            },
            "valueCapture": {
              "key": "valueCapture",
              "label": "Value Capture",
              "unit": "%",
              "unitValue": null,
              "value": 20
            },
            "cultivationCost": {
              "key": "cultivationCost",
              "label": "Cultivation Cost",
              "unit": null,
              "unitValue": "ha",
              "value": 0
            },
            "subsides": {
              "key": "subsides",
              "label": "Subsides",
              "unit": null,
              "unitValue": "ha",
              "value": 0
            }
          }
        },
        "cultivationCostPerYield": {
          "key": "cultivationCostPerYield",
          "label": "PA_PriceGuidance_CultivationCostPerYieldSegment",
          "unit": null,
          "unitValue": "ha",
          "attributes": null
        },
        "noOfAllowedCompetitors": 5,
        "roundDecimalNumber": 1,
        "title": "Price Guide",
        "title_translationKey": "PA_PriceGuidance_PriceGuide",
        "tooltipEnabled": false,
        "priceGuideData": {
          "checksList": [],
          "priceData": [],
          "qualityData": {},
          "profitData": {}
        },
        "entry": {
          "name": null,
          "seedPrice": 0,
          "hybridSpecificCost": 0,
          "hybridSpecificPremium": 0
        }
      }
    }
  },
  "defaultChartConfig": [
    {
      "title": "PA_PAIRWISECOMPARISON_TITLE",
      "key": "pairwise",
      "mode": ["Full", "Lite"],
      "isOrthogonalMode": false,
      "crop": [
        "corn",
        "cornsilage",
        "sunflower",
        "winterbarley",
        "winterwheat",
        "winteroilseeds",
        "soy"
      ],
      "region": ["eame", "latam", "amea"],
      "content": null
    },
    {
      "title": "PA_BREAKOUTS_TITLE",
      "key": "breakout",
      "mode": ["Full", "Lite"],
      "isOrthogonalMode": true,
      "crop": [
        "corn",
        "cornsilage",
        "sunflower",
        "winterbarley",
        "winterwheat",
        "winteroilseeds",
        "soy"
      ],
      "region": ["eame", "latam", "amea"]
    },
    {
      "title": "PA_BREAKOUTS_TITLE",
      "key": "breakout",
      "mode": ["Full", "Lite"],
      "isOrthogonalMode": false,
      "crop": [
        "corn",
        "cornsilage",
        "sunflower",
        "winterbarley",
        "winterwheat",
        "winteroilseeds",
        "soy"
      ],
      "region": ["eame", "latam", "amea"]
    },
    {
      "key": "timeline",
      "title": "PA_TIMELINE_TITLE",
      "mode": ["Full", "Lite"],
      "isOrthogonalMode": false,
      "crop": [
        "corn",
        "soy",
        "cornsilage",
        "sunflower",
        "winterbarley",
        "winterwheat",
        "winteroilseeds"
      ],
      "region": ["eame", "latam"]
    },
    {
      "key": "heatmap",
      "title": "PA_HEATMAP_TITLE",
      "mode": ["Full", "Lite"],
      "isOrthogonalMode": false,
      "crop": [
        "corn",
        "soy",
        "cornsilage",
        "sunflower",
        "winterbarley",
        "winterwheat",
        "winteroilseeds"
      ],
      "region": ["eame", "latam", "amea"]
    },
    {
      "key": "scatterPlot",
      "title": "PA_SCATTERPLOT_TITLE",
      "mode": ["Full", "Lite"],
      "isOrthogonalMode": false,
      "crop": [
        "corn",
        "cornsilage",
        "sunflower",
        "winterbarley",
        "winterwheat",
        "winteroilseeds",
        "soy"
      ],
      "region": ["eame", "latam"]
    },
    {
      "key": "scatterPlot",
      "title": "PA_SCATTERPLOT_TITLE",
      "mode": ["Full", "Lite"],
      "isOrthogonalMode": true,
      "crop": [
        "corn",
        "cornsilage",
        "sunflower",
        "winterbarley",
        "winterwheat",
        "winteroilseeds",
        "soy"
      ],
      "region": ["eame", "latam"]
    },
    {
      "key": "yieldTrend",
      "title": "PA_YIELDTREND_TITLE",
      "mode": ["Full", "Lite"],
      "isOrthogonalMode": false,
      "crop": [
        "corn",
        "soy",
        "cornsilage",
        "sunflower",
        "winterbarley",
        "winterwheat",
        "winteroilseeds"
      ],
      "region": ["eame", "latam"]
    },
    {
      "key": "priceGuide",
      "title": "PA_PRICEGUIDE_TITLE",
      "mode": ["Full", "Lite"],
      "isOrthogonalMode": false,
      "crop": ["corn", "cornsilage", "sunflower"],
      "region": ["eame"]
    },
    {
      "key": "multiHybrid",
      "title": "PA_MULTIHYBRIDREGRESSION_TITLE",
      "mode": ["Full", "Lite"],
      "isOrthogonalMode": true,
      "crop": [
        "corn",
        "cornsilage",
        "sunflower",
        "winterbarley",
        "winterwheat",
        "winteroilseeds",
        "soy"
      ],
      "region": ["eame", "latam"]
    }
  ],
  "defaultFilterView": {
    "experiment": {
      "order": 1,
      "label": "PA_filters-PRCornEAME_Experiment",
      "key": "experiment",
      "crop": [
        "corn",
        "cornsilage",
        "sunflower",
        "winterbarley",
        "winterwheat",
        "winteroilseeds",
        "soy"
      ],
      "region": ["eame", "latam", "amea"],
      "attributes": {
        "cornlatam": [
          {
            "filterName": "PA_filters-PRCornEAME_Years",
            "filterKey": "year",
            "data": []
          },
          {
            "filterName": "PA_ExperimentStage",
            "filterKey": "areaType",
            "data": []
          },
          {
            "filterName": "PA_TrialPlantingWindow",
            "filterKey": "plantingWindow",
            "data": []
          },
          {
            "filterName": "PA_filters-PR_TrialType",
            "filterKey": "trialType",
            "data": []
          },
          {
            "filterName": "PA_Trials",
            "filterKey": "trialId",
            "data": []
          }
        ],
        "corn": [
          {
            "filterName": "PA_filters-PRCornEAME_Years",
            "filterKey": "year",
            "data": []
          },
          {
            "filterName": "PA_PlantingDayMonth",
            "filterKey": "plantingDateNumber",
            "componentType": "range",
            "data": [],
            "pattern": "^[0-9]{2}[/][0-9]{2}$"
          },
          {
            "filterName": "PA_HarvestDayMonth",
            "filterKey": "harvestDateNumber",
            "componentType": "range",
            "data": [],
            "pattern": "^[0-9]{2}[/][0-9]{2}$"
          },
          {
            "filterName": "PA_filters-PR_TrialType",
            "filterKey": "trialType",
            "data": []
          },
          {
            "filterName": "PA_Trials",
            "filterKey": "trialId",
            "data": []
          }
        ],
        "cornsilage": [
          {
            "filterName": "PA_filters-PRCornEAME_Years",
            "filterKey": "year",
            "data": []
          },
          {
            "filterName": "PA_PlantingDayMonth",
            "filterKey": "plantingDateNumber",
            "componentType": "range",
            "data": [],
            "pattern": "^[0-9]{2}[/][0-9]{2}$"
          },
          {
            "filterName": "PA_HarvestDayMonth",
            "filterKey": "harvestDateNumber",
            "componentType": "range",
            "data": [],
            "pattern": "^[0-9]{2}[/][0-9]{2}$"
          },
          {
            "filterName": "PA_filters-PR_TrialType",
            "filterKey": "trialType",
            "data": []
          },
          {
            "filterName": "PA_Trials",
            "filterKey": "trialId",
            "data": []
          }
        ],
        "sunflower": [
          {
            "filterName": "PA_filters-PRCornEAME_Years",
            "filterKey": "year",
            "data": []
          },
          {
            "filterName": "PA_PlantingDayMonth",
            "filterKey": "plantingDateNumber",
            "componentType": "range",
            "data": [],
            "pattern": "^[0-9]{2}[/][0-9]{2}$"
          },
          {
            "filterName": "PA_HarvestDayMonth",
            "filterKey": "harvestDateNumber",
            "componentType": "range",
            "data": [],
            "pattern": "^[0-9]{2}[/][0-9]{2}$"
          },
          {
            "filterName": "PA_filters-PR_TrialType",
            "filterKey": "trialType",
            "data": []
          },
          {
            "filterName": "PA_Trials",
            "filterKey": "trialId",
            "data": []
          }
        ],
        "winterbarley": [
          {
            "filterName": "PA_filters-PRCornEAME_Years",
            "filterKey": "year",
            "data": []
          },
          {
            "filterName": "PA_PlantingDayMonth",
            "filterKey": "plantingDateNumber",
            "componentType": "range",
            "data": [],
            "pattern": "^[0-9]{2}[/][0-9]{2}$"
          },
          {
            "filterName": "PA_HarvestDayMonth",
            "filterKey": "harvestDateNumber",
            "componentType": "range",
            "data": [],
            "pattern": "^[0-9]{2}[/][0-9]{2}$"
          },
          {
            "filterName": "PA_filters-PR_TrialType",
            "filterKey": "trialType",
            "data": []
          },
          {
            "filterName": "PA_TrialSource",
            "filterKey": "trialSource",
            "data": []
          },
          {
            "filterName": "PA_trial_treatment",
            "filterKey": "trialTreatment",
            "data": []
          },
          {
            "filterName": "PA_Trials",
            "filterKey": "trialId",
            "data": []
          }
        ],
        "winterwheat": [
          {
            "filterName": "PA_filters-PRCornEAME_Years",
            "filterKey": "year",
            "data": []
          },
          {
            "filterName": "PA_PlantingDayMonth",
            "filterKey": "plantingDateNumber",
            "componentType": "range",
            "data": [],
            "pattern": "^[0-9]{2}[/][0-9]{2}$"
          },
          {
            "filterName": "PA_HarvestDayMonth",
            "filterKey": "harvestDateNumber",
            "componentType": "range",
            "data": [],
            "pattern": "^[0-9]{2}[/][0-9]{2}$"
          },
          {
            "filterName": "PA_filters-PR_TrialType",
            "filterKey": "trialType",
            "data": []
          },
          {
            "filterName": "PA_TrialSource",
            "filterKey": "trialSource",
            "data": []
          },
          {
            "filterName": "PA_trial_treatment",
            "filterKey": "trialTreatment",
            "data": []
          },
          {
            "filterName": "PA_Trials",
            "filterKey": "trialId",
            "data": []
          }
        ],
        "winteroilseeds": [
          {
            "filterName": "PA_filters-PRCornEAME_Years",
            "filterKey": "year",
            "data": []
          },
          {
            "filterName": "PA_PlantingDayMonth",
            "filterKey": "plantingDateNumber",
            "componentType": "range",
            "data": [],
            "pattern": "^[0-9]{2}[/][0-9]{2}$"
          },
          {
            "filterName": "PA_HarvestDayMonth",
            "filterKey": "harvestDateNumber",
            "componentType": "range",
            "data": [],
            "pattern": "^[0-9]{2}[/][0-9]{2}$"
          },
          {
            "filterName": "PA_filters-PR_TrialType",
            "filterKey": "trialType",
            "data": []
          },
          {
            "filterName": "PA_Trials",
            "filterKey": "trialId",
            "data": []
          }
        ],
        "soy": [
          {
            "filterName": "PA_filters-PRCornEAME_Years",
            "filterKey": "year",
            "data": []
          },
          {
            "filterName": "PA_ExperimentStage",
            "filterKey": "areaType",
            "data": []
          },
          {
            "filterName": "PA_filters-PR_TrialType",
            "filterKey": "trialType",
            "data": []
          },
          {
            "filterName": "PA_Trials",
            "filterKey": "trialId",
            "data": []
          }
        ]
      }
    },
    "performanceParameter": {
      "order": 2,
      "label": "PA_PerformanceParameterTab",
      "key": "performanceParameter",
      "crop": [
        "corn",
        "cornsilage",
        "sunflower",
        "winterbarley",
        "winterwheat",
        "winteroilseeds"
      ],
      "region": ["eame"],
      "attributes": {
        "corn": [
          {
            "filterName": "PA_PerformanceParameter",
            "filterKey": "alternateTrait",
            "data": []
          }
        ],
        "cornsilage": [
          {
            "filterName": "PA_PerformanceParameter",
            "filterKey": "alternateTrait",
            "data": []
          }
        ],
        "sunflower": [
          {
            "filterName": "PA_PerformanceParameter",
            "filterKey": "alternateTrait",
            "data": []
          }
        ],
        "winterbarley": [
          {
            "filterName": "PA_PerformanceParameter",
            "filterKey": "alternateTrait",
            "data": []
          }
        ],
        "winterwheat": [
          {
            "filterName": "PA_PerformanceParameter",
            "filterKey": "alternateTrait",
            "data": []
          }
        ],
        "winteroilseeds": [
          {
            "filterName": "PA_PerformanceParameter",
            "filterKey": "alternateTrait",
            "data": []
          }
        ]
      }
    },
    "comparison": {
      "order": 3,
      "label": "PA_filters-PRCornEAME_ComparisonProduct",
      "key": "comparison",
      "crop": [
        "corn",
        "cornsilage",
        "sunflower",
        "winterbarley",
        "winterwheat",
        "winteroilseeds",
        "soy"
      ],
      "region": ["eame", "latam", "amea"],
      "attributes": {
        "cornlatam": [
          {
            "filterName": "PA_filters-PREAME_OrthogonalMode",
            "filterKey": "orthogonalMode",
            "data": []
          },
          {
            "filterName": "PA_filters-PRCornEAME_ComparisonProductCompany",
            "filterKey": "checkCmp",
            "childKey": "entries",
            "data": []
          },
          {
            "filterName": "PA_filters-PRCornEAME_ComparisonProductName",
            "filterKey": "entries",
            "data": []
          }
        ],
        "corn": [
          {
            "filterName": "PA_filters-PREAME_Stage",
            "filterKey": "stage",
            "data": []
          },
          {
            "filterName": "PA_RelativeMaturity",
            "filterKey": "relativeMaturity",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PRCornEAME_ComparisonProductFAO",
            "filterKey": "checkFao",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_OrthogonalMode",
            "filterKey": "orthogonalMode",
            "data": []
          },
          {
            "filterName": "PA_filters-PRCornEAME_ComparisonProductCompany",
            "filterKey": "checkCmp",
            "childKey": "entries",
            "data": []
          },
          {
            "filterName": "PA_filters-PRCornEAME_ComparisonProductName",
            "filterKey": "entries",
            "data": []
          }
        ],
        "cornsilage": [
          {
            "filterName": "PA_filters-PREAME_Stage",
            "filterKey": "stage",
            "data": []
          },
          {
            "filterName": "PA_RelativeMaturity",
            "filterKey": "relativeMaturity",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PRCornEAME_ComparisonProductFAO",
            "filterKey": "checkFao",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_OrthogonalMode",
            "filterKey": "orthogonalMode",
            "data": []
          },
          {
            "filterName": "PA_filters-PRCornEAME_ComparisonProductCompany",
            "filterKey": "checkCmp",
            "childKey": "entries",
            "data": []
          },
          {
            "filterName": "PA_filters-PRCornEAME_ComparisonProductName",
            "filterKey": "entries",
            "data": []
          }
        ],
        "sunflower": [
          {
            "filterName": "PA_filters-PREAME_Stage",
            "filterKey": "stage",
            "data": []
          },
          {
            "filterName": "PA_filters-PRSunflowerEAME_MaturityGroup",
            "filterKey": "checkMg",
            "data": []
          },
          {
            "filterName": "PA_filters-PRSunflowerEAME_HerbicideTechnology",
            "filterKey": "checkHerbicide",
            "data": []
          },
          {
            "filterName": "PA_filters-PRSunflowerEAME_OilContent",
            "filterKey": "checkOilContent",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_OrthogonalMode",
            "filterKey": "orthogonalMode",
            "data": []
          },
          {
            "filterName": "PA_filters-PRCornEAME_ComparisonProductCompany",
            "filterKey": "checkCmp",
            "childKey": "entries",
            "data": []
          },
          {
            "filterName": "PA_filters-PRCornEAME_ComparisonProductName",
            "filterKey": "entries",
            "data": []
          }
        ],
        "winterbarley": [
          {
            "filterName": "PA_filters-PREAME_OrthogonalMode",
            "filterKey": "orthogonalMode",
            "data": []
          },
          {
            "filterName": "PA_filters-PRCornEAME_ComparisonProductCompany",
            "filterKey": "checkCmp",
            "childKey": "entries",
            "data": []
          },
          {
            "filterName": "PA_filters-PRCornEAME_ComparisonProductName",
            "filterKey": "entries",
            "data": []
          }
        ],
        "winterwheat": [
          {
            "filterName": "PA_filters-PREAME_OrthogonalMode",
            "filterKey": "orthogonalMode",
            "data": []
          },
          {
            "filterName": "PA_filters-PRCornEAME_ComparisonProductCompany",
            "filterKey": "checkCmp",
            "childKey": "entries",
            "data": []
          },
          {
            "filterName": "PA_filters-PRCornEAME_ComparisonProductName",
            "filterKey": "entries",
            "data": []
          }
        ],
        "winteroilseeds": [
          {
            "filterName": "PA_filters-PREAME_Stage",
            "filterKey": "stage",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_OrthogonalMode",
            "filterKey": "orthogonalMode",
            "data": []
          },
          {
            "filterName": "PA_filters-PRCornEAME_ComparisonProductCompany",
            "filterKey": "checkCmp",
            "childKey": "entries",
            "data": []
          },
          {
            "filterName": "PA_filters-PRCornEAME_ComparisonProductName",
            "filterKey": "entries",
            "data": []
          }
        ],
        "soy": [
          {
            "filterName": "PA_filters-PREAME_OrthogonalMode",
            "filterKey": "orthogonalMode",
            "data": []
          },
          {
            "filterName": "PA_RelativeMaturity",
            "filterKey": "rmtN",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PRCornEAME_ComparisonProductCompany",
            "filterKey": "checkCmp",
            "childKey": "entries",
            "data": []
          },
          {
            "filterName": "PA_filters-PRCornEAME_ComparisonProductName",
            "filterKey": "entries",
            "data": []
          }
        ]
      }
    },
    "market": {
      "order": 4,
      "label": "PA_filters-PRCornEAME_Geographical/Market",
      "key": "market",
      "crop": [
        "corn",
        "cornsilage",
        "sunflower",
        "winterbarley",
        "winterwheat",
        "winteroilseeds",
        "soy"
      ],
      "region": ["eame", "latam", "amea"],
      "attributes": {
        "cornlatam": [
          {
            "filterName": "PA_Mesoregion",
            "filterKey": "mesoregionCode",
            "data": []
          },
          {
            "filterName": "PA_State",
            "filterKey": "st_name",
            "data": []
          },
          {
            "filterName": "PA_filters-PRSunflowerEAME_TPP",
            "filterKey": "tpp",
            "data": []
          },
          {
            "filterName": "PA_EnvironmentClass",
            "filterKey": "envClass",
            "data": []
          }
        ],
        "corn": [
          {
            "filterName": "PA_Locations",
            "filterKey": "country",
            "childKey": "state",
            "data": []
          },
          {
            "filterName": "PA_State",
            "filterKey": "state",
            "data": []
          }
        ],
        "cornsilage": [
          {
            "filterName": "PA_Locations",
            "filterKey": "country",
            "childKey": "state",
            "data": []
          },
          {
            "filterName": "PA_State",
            "filterKey": "state",
            "data": []
          }
        ],
        "sunflower": [
          {
            "filterName": "PA_Locations",
            "filterKey": "country",
            "childKey": "state",
            "data": []
          },
          {
            "filterName": "PA_State",
            "filterKey": "state",
            "data": []
          },
          {
            "filterName": "PA_filters-PRSunflowerEAME_TPP",
            "filterKey": "tpp",
            "data": []
          }
        ],
        "winterbarley": [
          {
            "filterName": "PA_Locations",
            "filterKey": "country",
            "childKey": "state",
            "data": []
          },
          {
            "filterName": "PA_State",
            "filterKey": "state",
            "data": []
          }
        ],
        "winterwheat": [
          {
            "filterName": "PA_Locations",
            "filterKey": "country",
            "childKey": "state",
            "data": []
          },
          {
            "filterName": "PA_State",
            "filterKey": "state",
            "data": []
          }
        ],
        "winteroilseeds": [
          {
            "filterName": "PA_Locations",
            "filterKey": "country",
            "childKey": "state",
            "data": []
          },
          {
            "filterName": "PA_State",
            "filterKey": "state",
            "data": []
          }
        ],
        "soy": [
          {
            "filterName": "PA_macroregion_code",
            "filterKey": "macroregionCode",
            "data": []
          },
          {
            "filterName": "PA_rec",
            "filterKey": "rec",
            "data": []
          },
          {
            "filterName": "PA_State",
            "filterKey": "stateCode",
            "data": []
          }
        ],
        "soylatam": [
          {
            "filterName": "PA_macroregion_code",
            "filterKey": "macroregionCode",
            "data": []
          },
          {
            "filterName": "PA_rec",
            "filterKey": "rec",
            "data": []
          },
          {
            "filterName": "PA_State",
            "filterKey": "stateCode",
            "data": []
          },
          {
            "filterName": "PA_EnvironmentClass",
            "filterKey": "envClass",
            "data": []
          }
        ]
      }
    },
    "management": {
      "order": 5,
      "label": "PA_filters-PRCornEAME_Management",
      "key": "management",
      "crop": [
        "corn",
        "cornsilage",
        "sunflower",
        "winterbarley",
        "winterwheat",
        "winteroilseeds",
        "soy"
      ],
      "region": ["eame", "latam", "amea"],
      "attributes": {
        "cornlatam": [
          {
            "filterName": "PA_cropRegion-PRCORNEAME_YieldLevel",
            "filterKey": "genericYield",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PREAME_Yield-TrialMean",
            "filterKey": "avgYield",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PRLATAM_Yield-EntryProduct",
            "filterKey": "yield",
            "componentType": "range",
            "data": []
          }
        ],
        "corn": [
          {
            "filterName": "PA_cropRegion-PRCORNEAME_YieldLevel",
            "filterKey": "genericYield",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_PreviousCrop",
            "filterKey": "previousCrop",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_Cultivation",
            "filterKey": "cultivation",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_HarvestPopulation",
            "filterKey": "avgHarvestPopulation",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_PlantingDensity",
            "filterKey": "plantingDensity",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_Yield-TrialMean",
            "filterKey": "avgYield",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_Yield-TestProduct",
            "filterKey": "yield",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_Moisture-TrialMean",
            "filterKey": "avgGrainMoisture",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_Moisture-TestProduct",
            "filterKey": "grainMoisture",
            "componentType": "range",
            "data": []
          }
        ],
        "cornsilage": [
          {
            "filterName": "PA_cropRegion-PRCORNEAME_YieldLevel",
            "filterKey": "genericYield",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_PreviousCrop",
            "filterKey": "previousCrop",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_Cultivation",
            "filterKey": "cultivation",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_HarvestPopulation",
            "filterKey": "avgHarvestPopulation",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_Yield-TrialMean",
            "filterKey": "avgYield",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_Yield-TestProduct",
            "filterKey": "yield",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_Moisture-TrialMean",
            "filterKey": "avgGrainMoisture",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_Moisture-TestProduct",
            "filterKey": "grainMoisture",
            "componentType": "range",
            "data": []
          }
        ],
        "sunflower": [
          {
            "filterName": "PA_cropRegion-PRCORNEAME_YieldLevel",
            "filterKey": "genericYield",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_PreviousCrop",
            "filterKey": "previousCrop",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_Cultivation",
            "filterKey": "cultivation",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_HarvestPopulation",
            "filterKey": "avgHarvestPopulation",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_Yield-TrialMean",
            "filterKey": "avgYield",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_Yield-TestProduct",
            "filterKey": "yield",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_Moisture-TrialMean",
            "filterKey": "avgGrainMoisture",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_Moisture-TestProduct",
            "filterKey": "grainMoisture",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_OIL_P-TrialMean",
            "filterKey": "avgOilPct",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_OIL_P-TestProduct",
            "filterKey": "oilPct",
            "data": []
          }
        ],
        "winterbarley": [
          {
            "filterName": "PA_cropRegion-PRCORNEAME_YieldLevel",
            "filterKey": "genericYield",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_PreviousCrop",
            "filterKey": "previousCrop",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_Yield-TrialMean",
            "filterKey": "avgYield",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_Yield-TestProduct",
            "filterKey": "yield",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_Moisture-TrialMean",
            "filterKey": "avgGrainMoisture",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_Moisture-TestProduct",
            "filterKey": "grainMoisture",
            "componentType": "range",
            "data": []
          }
        ],
        "winterwheat": [
          {
            "filterName": "PA_cropRegion-PRCORNEAME_YieldLevel",
            "filterKey": "genericYield",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_PreviousCrop",
            "filterKey": "previousCrop",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_Cultivation",
            "filterKey": "cultivation",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_HarvestPopulation",
            "filterKey": "avgHarvestPopulation",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_Yield-TrialMean",
            "filterKey": "avgYield",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_Yield-TestProduct",
            "filterKey": "yield",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_Moisture-TrialMean",
            "filterKey": "avgGrainMoisture",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_Moisture-TestProduct",
            "filterKey": "grainMoisture",
            "componentType": "range",
            "data": []
          }
        ],
        "winteroilseeds": [
          {
            "filterName": "PA_cropRegion-PRCORNEAME_YieldLevel",
            "filterKey": "genericYield",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PREAME_Cultivation",
            "filterKey": "cultivation",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_PlantingDensity",
            "filterKey": "plantingDensity",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_Yield-TrialMean",
            "filterKey": "avgYield",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_Yield-TestProduct",
            "filterKey": "yield",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_Moisture-TrialMean",
            "filterKey": "avgGrainMoisture",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_Moisture-TestProduct",
            "filterKey": "grainMoisture",
            "componentType": "range",
            "data": []
          }
        ],
        "soy": [
          {
            "filterName": "PA_cropRegion-PRCORNEAME_YieldLevel",
            "filterKey": "genericYield",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PREAME_Yield-TrialMean",
            "filterKey": "avgYield",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PRLATAM_Yield-EntryProduct",
            "filterKey": "yield",
            "componentType": "range",
            "data": []
          }
        ]
      }
    },
    "weather": {
      "order": 6,
      "label": "PA_filters-PRCornEAME_Weather",
      "key": "weather",
      "crop": [
        "corn",
        "cornsilage",
        "sunflower",
        "winterbarley",
        "winterwheat",
        "soy"
      ],
      "region": ["eame", "latam", "amea"],
      "attributes": {
        "cornlatam": [
          {
            "filterName": "PA_Timeline_EnsoShort",
            "filterKey": "enso",
            "data": []
          }
        ],
        "corn": [
          {
            "filterName": "PA_Temperature",
            "filterKey": "temperature",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_Precipitation",
            "filterKey": "precipitation",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_Radiation",
            "filterKey": "radiation",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_Humidity",
            "filterKey": "humidity",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_cropRegion-PRCORNEAME_Temperature/PrecipitationRatio",
            "filterKey": "tempPrecip",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_Temperature/PrecipitationRatioRange",
            "filterKey": "tempPrecipRaw",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_GDD",
            "filterKey": "gdd",
            "componentType": "range",
            "data": []
          }
        ],
        "cornsilage": [
          {
            "filterName": "PA_Temperature",
            "filterKey": "temperature",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_Precipitation",
            "filterKey": "precipitation",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_Radiation",
            "filterKey": "radiation",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_Humidity",
            "filterKey": "humidity",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_cropRegion-PRCORNEAME_Temperature/PrecipitationRatio",
            "filterKey": "tempPrecip",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_Temperature/PrecipitationRatioRange",
            "filterKey": "tempPrecipRaw",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_GDD",
            "filterKey": "gdd",
            "componentType": "range",
            "data": []
          }
        ],
        "sunflower": [
          {
            "filterName": "PA_Temperature",
            "filterKey": "temperature",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_Precipitation",
            "filterKey": "precipitation",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_Radiation",
            "filterKey": "radiation",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_cropRegion-PRCORNEAME_Temperature/PrecipitationRatio",
            "filterKey": "tempPrecip",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_Temperature/PrecipitationRatioRange",
            "filterKey": "tempPrecipRaw",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_GDD",
            "filterKey": "gdd",
            "componentType": "range",
            "data": []
          }
        ],
        "winterbarley": [
          {
            "filterName": "PA_cropRegion-PRCORNEAME_Temperature/PrecipitationRatio",
            "filterKey": "tempPrecip",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_Temperature/PrecipitationRatioRange",
            "filterKey": "tempPrecipRaw",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_GDD",
            "filterKey": "gdd",
            "componentType": "range",
            "data": []
          }
        ],
        "winterwheat": [
          {
            "filterName": "PA_cropRegion-PRCORNEAME_Temperature/PrecipitationRatio",
            "filterKey": "tempPrecip",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_Temperature/PrecipitationRatioRange",
            "filterKey": "tempPrecipRaw",
            "componentType": "range",
            "data": []
          },
          {
            "filterName": "PA_filters-PREAME_GDD",
            "filterKey": "gdd",
            "componentType": "range",
            "data": []
          }
        ],
        "soy": [
          {
            "filterName": "PA_EnvironmentClass",
            "filterKey": "envClass",
            "data": []
          }
        ],
        "soylatam": [
          {
            "filterName": "PA_Timeline_EnsoShort",
            "filterKey": "enso",
            "data": []
          }
        ]
      }
    },
    "soil": {
      "order": 7,
      "label": "PA_Soil",
      "key": "soil",
      "crop": [
        "corn",
        "cornsilage",
        "sunflower",
        "winterbarley",
        "winterwheat",
        "winteroilseeds",
        "soy"
      ],
      "region": ["eame", "latam", "amea"],
      "attributes": {
        "cornlatam": [
          {
            "filterName": "PA_cropRegion-PRCORNEAME_Texture",
            "filterKey": "texture",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          }
        ],
        "corn": [
          {
            "filterName": "PA_cropRegion-PRCORNEAME_Texture",
            "filterKey": "texture",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCORNEAME_WaterHoldingCapacity",
            "filterKey": "waterHoldingCapacity",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_Drainage",
            "filterKey": "drainage",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_pH",
            "filterKey": "ph",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_OrganicMatter",
            "filterKey": "organicMatter",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_CEC",
            "filterKey": "cec",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          }
        ],
        "cornsilage": [
          {
            "filterName": "PA_cropRegion-PRCORNEAME_Texture",
            "filterKey": "texture",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCORNEAME_WaterHoldingCapacity",
            "filterKey": "waterHoldingCapacity",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_Drainage",
            "filterKey": "drainage",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_pH",
            "filterKey": "ph",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_OrganicMatter",
            "filterKey": "organicMatter",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_CEC",
            "filterKey": "cec",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          }
        ],
        "sunflower": [
          {
            "filterName": "PA_cropRegion-PRCORNEAME_Texture",
            "filterKey": "texture",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCORNEAME_WaterHoldingCapacity",
            "filterKey": "waterHoldingCapacity",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_Drainage",
            "filterKey": "drainage",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_pH",
            "filterKey": "ph",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_OrganicMatter",
            "filterKey": "organicMatter",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_CEC",
            "filterKey": "cec",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          }
        ],
        "winterbarley": [
          {
            "filterName": "PA_cropRegion-PRCORNEAME_Texture",
            "filterKey": "texture",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCORNEAME_WaterHoldingCapacity",
            "filterKey": "waterHoldingCapacity",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_Drainage",
            "filterKey": "drainage",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_pH",
            "filterKey": "ph",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_OrganicMatter",
            "filterKey": "organicMatter",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_CEC",
            "filterKey": "cec",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          }
        ],
        "winterwheat": [
          {
            "filterName": "PA_cropRegion-PRCORNEAME_Texture",
            "filterKey": "texture",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCORNEAME_WaterHoldingCapacity",
            "filterKey": "waterHoldingCapacity",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_Drainage",
            "filterKey": "drainage",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_pH",
            "filterKey": "ph",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_OrganicMatter",
            "filterKey": "organicMatter",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_CEC",
            "filterKey": "cec",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          }
        ],
        "winteroilseeds": [
          {
            "filterName": "PA_cropRegion-PRCORNEAME_Texture",
            "filterKey": "texture",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCORNEAME_WaterHoldingCapacity",
            "filterKey": "waterHoldingCapacity",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_Drainage",
            "filterKey": "drainage",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_pH",
            "filterKey": "ph",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_OrganicMatter",
            "filterKey": "organicMatter",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          },
          {
            "filterName": "PA_filters-PRCornEAME_CEC",
            "filterKey": "cec",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          }
        ],
        "soy": [
          {
            "filterName": "PA_cropRegion-PRCORNEAME_Texture",
            "filterKey": "texture",
            "data": [],
            "info": {
              "title": null,
              "list": null,
              "note": null
            }
          }
        ]
      }
    }
  },
  "defaultMapThreshHolds": {
    "corn": [
      {
        "color": "#EB4B4B",
        "label": "< -5%",
        "isLessThan": true,
        "value": -5
      },
      {
        "color": "#E99921",
        "label": "-5% to 5%",
        "from": -5,
        "to": 5,
        "value": 5
      },
      {
        "color": "#19A04B",
        "label": "> 5%",
        "isGreaterThan": true,
        "value": 5
      }
    ],
    "cornsilage": [
      {
        "color": "#EB4B4B",
        "label": "< -5%",
        "isLessThan": true,
        "value": -5
      },
      {
        "color": "#E99921",
        "label": "-5% to 5%",
        "from": -5,
        "to": 5,
        "value": 5
      },
      {
        "color": "#19A04B",
        "label": "> 5%",
        "isGreaterThan": true,
        "value": 5
      }
    ],
    "sunflower": [
      {
        "color": "#EB4B4B",
        "label": "< -5%",
        "isLessThan": true,
        "value": -5
      },
      {
        "color": "#E99921",
        "label": "-5% to 5%",
        "from": -5,
        "to": 5,
        "value": 5
      },
      {
        "color": "#19A04B",
        "label": "> 5%",
        "isGreaterThan": true,
        "value": 5
      }
    ],
    "winterbarley": [
      {
        "color": "#EB4B4B",
        "label": "< -5%",
        "isLessThan": true,
        "value": -5
      },
      {
        "color": "#E99921",
        "label": "-5% to 5%",
        "from": -5,
        "to": 5,
        "value": 5
      },
      {
        "color": "#19A04B",
        "label": "> 5%",
        "isGreaterThan": true,
        "value": 5
      }
    ],
    "winterwheat": [
      {
        "color": "#EB4B4B",
        "label": "< -5%",
        "isLessThan": true,
        "value": -5
      },
      {
        "color": "#E99921",
        "label": "-5% to 5%",
        "from": -5,
        "to": 5,
        "value": 5
      },
      {
        "color": "#19A04B",
        "label": "> 5%",
        "isGreaterThan": true,
        "value": 5
      }
    ],
    "winteroilseeds": [
      {
        "color": "#EB4B4B",
        "label": "< -5%",
        "isLessThan": true,
        "value": -5
      },
      {
        "color": "#E99921",
        "label": "-5% to 5%",
        "from": -5,
        "to": 5,
        "value": 5
      },
      {
        "color": "#19A04B",
        "label": "> 5%",
        "isGreaterThan": true,
        "value": 5
      }
    ],
    "soy": [
      {
        "color": "#EB4B4B",
        "label": "< -5%",
        "isLessThan": true,
        "value": -5
      },
      {
        "color": "#E99921",
        "label": "-5% to 5%",
        "from": -5,
        "to": 5,
        "value": 5
      },
      {
        "color": "#19A04B",
        "label": "> 5%",
        "isGreaterThan": true,
        "value": 5
      }
    ]
  },
  "defaultBreakoutCards": [
    {
      "key": "chart_summary",
      "title": "PA_entryPerformance_Summary",
      "crop": [
        "corn",
        "cornsilage",
        "sunflower",
        "winterbarley",
        "winterwheat",
        "winteroilseeds"
      ],
      "region": ["eame"]
    },
    {
      "key": "tempPrecip",
      "title": "PA_cropRegion-PRCORNEAME_Temperature/PrecipitationRatio",
      "crop": [
        "corn",
        "cornsilage",
        "sunflower",
        "winterbarley",
        "winterwheat"
      ],
      "region": ["eame"]
    },
    {
      "key": "yield_lvl",
      "title": "PA_cropRegion-PRCORNEAME_YieldLevel",
      "crop": [
        "corn",
        "cornsilage",
        "sunflower",
        "winterbarley",
        "winterwheat",
        "winteroilseeds",
        "soy"
      ],
      "region": ["eame", "latam", "amea"]
    },
    {
      "key": "elevation",
      "title": "PA_elevation",
      "crop": ["corn", "soy"],
      "region": ["latam"]
    },
    {
      "key": "meso",
      "title": "PA_Mesoregion",
      "crop": ["corn"],
      "region": ["latam"]
    },
    {
      "key": "macroregionCode",
      "title": "PA_macroregion_code",
      "crop": ["soy"],
      "region": ["latam"]
    },
    {
      "key": "tpp",
      "title": "PA_tpp",
      "crop": ["corn"],
      "region": ["latam"]
    },
    {
      "key": "texture",
      "title": "PA_cropRegion-PRCORNEAME_Texture_Soil",
      "crop": [
        "corn",
        "cornsilage",
        "sunflower",
        "winterbarley",
        "winterwheat",
        "winteroilseeds"
      ],
      "region": ["eame"]
    },
    {
      "key": "plantingWindow",
      "title": "PA_TrialPlantingWindow",
      "crop": ["corn", "soy"],
      "region": ["latam"]
    }
  ],
  "regionThresholds": {
    "corn": [
      {
        "color": "#EB4B4B",
        "label": "< 7",
        "isLessThan": true,
        "value": 7
      },
      {
        "color": "#E99921",
        "label": "7 to 10",
        "from": 7,
        "to": 10,
        "value": 10
      },
      {
        "color": "#E99921",
        "label": "10 to 13",
        "from": 10,
        "to": 13,
        "value": 13
      },
      {
        "color": "#E99921",
        "label": "13 to 16",
        "from": 13,
        "to": 16,
        "value": 16
      },
      {
        "color": "#19A04B",
        "label": "> 16",
        "isGreaterThan": true,
        "value": 16
      }
    ],
    "cornsilage": [
      {
        "color": "#EB4B4B",
        "label": "< 10",
        "isLessThan": true,
        "value": 10
      },
      {
        "color": "#E99921",
        "label": "10 to 15",
        "from": 10,
        "to": 15,
        "value": 15
      },
      {
        "color": "#E99921",
        "label": "15 to 20",
        "from": 15,
        "to": 20,
        "value": 20
      },
      {
        "color": "#E99921",
        "label": "20 to 30",
        "from": 20,
        "to": 30,
        "value": 30
      },
      {
        "color": "#19A04B",
        "label": "> 30",
        "isGreaterThan": true,
        "value": 30
      }
    ],
    "sunflower": [
      {
        "color": "#EB4B4B",
        "label": "< 5",
        "isLessThan": true,
        "value": 5
      },
      {
        "color": "#E99921",
        "label": "5 to 15",
        "from": 5,
        "to": 15,
        "value": 15
      },
      {
        "color": "#E99921",
        "label": "15 to 30",
        "from": 15,
        "to": 30,
        "value": 30
      },
      {
        "color": "#E99921",
        "label": "30 to 50",
        "from": 30,
        "to": 50,
        "value": 50
      },
      {
        "color": "#19A04B",
        "label": "> 50",
        "isGreaterThan": true,
        "value": 50
      }
    ],
    "winterbarley": [
      {
        "color": "#EB4B4B",
        "label": "< 3",
        "isLessThan": true,
        "value": 3
      },
      {
        "color": "#E99921",
        "label": "3 to 7",
        "from": 3,
        "to": 7,
        "value": 7
      },
      {
        "color": "#E99921",
        "label": "7 to 9",
        "from": 7,
        "to": 9,
        "value": 9
      },
      {
        "color": "#E99921",
        "label": "9 to 13",
        "from": 9,
        "to": 13,
        "value": 13
      },
      {
        "color": "#19A04B",
        "label": "> 13",
        "isGreaterThan": true,
        "value": 13
      }
    ],
    "winterwheat": [
      {
        "color": "#EB4B4B",
        "label": "< 3",
        "isLessThan": true,
        "value": 3
      },
      {
        "color": "#E99921",
        "label": "3 to 7",
        "from": 3,
        "to": 7,
        "value": 7
      },
      {
        "color": "#E99921",
        "label": "7 to 9",
        "from": 7,
        "to": 9,
        "value": 9
      },
      {
        "color": "#E99921",
        "label": "9 to 13",
        "from": 9,
        "to": 13,
        "value": 13
      },
      {
        "color": "#19A04B",
        "label": "> 13",
        "isGreaterThan": true,
        "value": 13
      }
    ],
    "winteroilseeds": [
      {
        "color": "#EB4B4B",
        "label": "< 10",
        "isLessThan": true,
        "value": 10
      },
      {
        "color": "#E99921",
        "label": "10 to 30",
        "from": 10,
        "to": 30,
        "value": 30
      },
      {
        "color": "#E99921",
        "label": "30 to 40",
        "from": 30,
        "to": 40,
        "value": 40
      },
      {
        "color": "#E99921",
        "label": "40 to 60",
        "from": 40,
        "to": 60,
        "value": 60
      },
      {
        "color": "#19A04B",
        "label": "> 60",
        "isGreaterThan": true,
        "value": 60
      }
    ],
    "soy": []
  },
  "cropConfig": {
    "corn": {
      "supportsTprFilter": true,
      "priceGuideType": "chart",
      "supportsCustomThreshold": true,
      "showRmFilter": true,
      "showMinLocations": true,
      "defaultMinLocations": 8,
      "showMstColumn": true
    },
    "cornsilage": {
      "supportsTprFilter": true,
      "priceGuideType": "table",
      "supportsCustomThreshold": true,
      "showRmFilter": true,
      "showMinLocations": true,
      "defaultMinLocations": 8,
      "showMstColumn": true
    },
    "sunflower": {
      "supportsTprFilter": false,
      "priceGuideType": "chart",
      "supportsCustomThreshold": true,
      "showRmFilter": false,
      "showMinLocations": true,
      "defaultMinLocations": 8,
      "showMstColumn": true
    },
    "winterbarley": {
      "supportsTprFilter": false,
      "priceGuideType": "chart",
      "supportsCustomThreshold": true,
      "showRmFilter": false,
      "showMinLocations": true,
      "defaultMinLocations": 8,
      "showMstColumn": true
    },
    "winterwheat": {
      "supportsTprFilter": false,
      "priceGuideType": "chart",
      "supportsCustomThreshold": true,
      "showRmFilter": false,
      "showMinLocations": true,
      "defaultMinLocations": 8,
      "showMstColumn": true
    },
    "winteroilseeds": {
      "supportsTprFilter": false,
      "priceGuideType": "chart",
      "supportsCustomThreshold": true,
      "showRmFilter": false,
      "showMinLocations": true,
      "defaultMinLocations": 8,
      "showMstColumn": true
    },
    "soy": {
      "supportsTprFilter": false,
      "priceGuideType": null,
      "supportsCustomThreshold": false,
      "showRmFilter": true,
      "showMinLocations": true,
      "defaultMinLocations": 8,
      "showMstColumn": false
    }
  },
  "regionConfig": {
    "EAME": {
      "apiFormat": "escaped",
      "apiVersion": "v2",
      "hasTieColumn": false,
      "supportsCustomThreshold": true,
      "showRmFilter": true,
      "showMinLocations": true,
      "defaultMinLocations": 8
    },
    "LATAM": {
      "apiFormat": "json",
      "apiVersion": "v1",
      "hasTieColumn": true,
      "supportsCustomThreshold": false,
      "showRmFilter": true,
      "showMinLocations": true,
      "defaultMinLocations": 8
    }
  }
}
